exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".buffered {\n\tmargin-bottom: 23px;\n}\n\nbody {\n\tbackground-color: #ddd;\n}\n\ni.material-icons {\n\tvertical-align: middle;\n\tmargin-top: -3px;\n}\n\na {\n\ttext-decoration: none !important;\n}\n", ""]);

// exports
